import { ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../mock/data';

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-32 bg-ink">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="eyebrow">What We Build</div>
          <h2 className="section-title">All types of fencing &amp; decks &mdash; built better.</h2>
          <p className="section-lede">
            From backyard privacy fences to sprawling ranch lines and multi-level composite decks, our crews specialize in every material and every scale.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <article
              key={s.id}
              className="group relative rounded-md overflow-hidden bg-ink-panel border border-white/8 hover:border-gold/60 shadow-lg hover:shadow-2xl transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1"
              style={{ transitionDelay: `${i * 40}ms` }}
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-[900ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent" />
                <div className="absolute top-3 right-3 text-[10px] uppercase tracking-wider text-ink bg-gold font-bold px-2.5 py-1 rounded">from {s.from}</div>
              </div>
              <div className="p-6">
                <h3 className="font-display uppercase text-2xl text-cream tracking-tight">{s.title}</h3>
                <p className="mt-3 text-cream/65 text-sm leading-relaxed">{s.blurb}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {s.features.map(f => (
                    <span key={f} className="text-[10px] uppercase tracking-wider px-2 py-1 rounded border border-white/10 text-cream/70">{f}</span>
                  ))}
                </div>
                <a
                  href="#quote"
                  className="mt-5 inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-bold text-gold group-hover:text-gold-light transition-colors"
                >
                  Get a quote
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a href="#quote" className="btn-primary">Get a free quote on any service</a>
        </div>
      </div>
    </section>
  );
}
